import React from "react";
import { connect } from "react-redux";
import WeekTableDesktop from "./desktop.jsx";
import WeekTableMobile from "./mobile.jsx";

/**
 * Generates a <tbody> for a table of selectable days
 * Table can either be a row a type (Desktop mode)
 * or a column a type (Mobile mode) 
 */

export default connect(state => ({ items: state.items }))(function WeekTable(props) {
    if (props.isMobile) {
        return <WeekTableMobile {...props} />
    } else {
        return <WeekTableDesktop {...props} />
    }
})






// WEBPACK FOOTER //
// ./flexi/weektable/index.jsx